// extracted by mini-css-extract-plugin
export default {"charts":"Charts_charts__5ZmMf"};